export default __webpack_public_path__ + "static/media/CB222439-rise-mountains.00df8ef2.jpg";